module.exports = __webpack_public_path__ + "img/instagram.f833ba5d.svg";